<template>
  <div class="sales-line-menu" role="menu">
    <button
      v-for="salesLine in salesLines"
      :key="salesLine.routeName"
      type="button"
      role="menuitem"
      class="sales-line-menu-item d-flex align-items-center w-100"
      :data-testid="salesLine.testId"
      @click="emit('select', salesLine)"
    >
      <span class="sales-line-menu-icon d-flex align-items-center justify-content-center">
        <i class="mdi-20px" :class="salesLine.icon" />
      </span>
      <span class="sales-line-menu-label">{{ $t(salesLine.labelKey) }}</span>
    </button>
  </div>
</template>

<script setup>
// The list a flex retailer picks from before starting an application, shown next to the sidebar's
// "Yeni Başvuru" button. It renders whatever it is handed and reports the choice back: opening,
// closing and routing all stay with the button, which is the element the click-outside is bound to.
defineProps({
  salesLines: {
    required: true,
    type: Array
  }
})

const emit = defineEmits(['select'])
</script>

<style scoped>
.sales-line-menu {
  background-color: var(--white);
  border-radius: 6px;
  box-shadow:
    0 1px 3px rgba(24, 24, 25, 0.1),
    0 0 4px rgba(24, 24, 25, 0.1);
  overflow: hidden;
  width: 212px;
}

.sales-line-menu-item {
  background-color: var(--white);
  border: none;
  gap: 10px;
  padding: 13px 8px 13px 14px;
  text-align: left;
}

.sales-line-menu-item + .sales-line-menu-item {
  border-top: 1px solid #eff0f0;
}

.sales-line-menu-item:hover {
  background-color: #ece5fc;
}

/* The icon keeps its own lighter tile on the hovered row, so it needs the lift to stay legible. */
.sales-line-menu-item:hover .sales-line-menu-icon {
  box-shadow: 0 1px 2px rgba(24, 24, 25, 0.1);
}

.sales-line-menu-icon {
  background-color: #f4f0ff;
  border-radius: 4px;
  color: var(--neutral-900);
  flex-shrink: 0;
  height: 28px;
  width: 28px;
}

.sales-line-menu-label {
  color: var(--secondary);
  font-size: 14.222px;
  line-height: 1.5;
}
</style>
